module.exports = __webpack_public_path__ + "img/beach.674c9cd8.jpg";